import { render, staticRenderFns } from "./ActivatedSuccessfully.vue?vue&type=template&id=22299734"
import script from "./ActivatedSuccessfully.vue?vue&type=script&lang=js"
export * from "./ActivatedSuccessfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports